import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
interface Sale {
  name: string;
  location: string;
}
const sales: Sale[] = [{
  name: 'James',
  location: 'London, UK'
}, {
  name: 'Michael',
  location: 'Manchester, UK'
}, {
  name: 'David',
  location: 'Dublin, Ireland'
}, {
  name: 'Chris',
  location: 'Toronto, Canada'
}, {
  name: 'Ryan',
  location: 'Sydney, Australia'
}, {
  name: 'Daniel',
  location: 'New York, USA'
}, {
  name: 'Mark',
  location: 'Los Angeles, USA'
}, {
  name: 'Liam',
  location: 'Glasgow, UK'
}, {
  name: 'Ethan',
  location: 'Auckland, New Zealand'
}, {
  name: 'Jack',
  location: 'Chicago, USA'
}, {
  name: 'Oliver',
  location: 'Birmingham, UK'
}, {
  name: 'Noah',
  location: 'Melbourne, Australia'
}, {
  name: 'Lucas',
  location: 'Vancouver, Canada'
}, {
  name: 'Harry',
  location: 'Leeds, UK'
}, {
  name: 'Connor',
  location: 'Boston, USA'
}];
const VISIBLE_MS = 5000;
const HIDDEN_MS = 8000;
export function SalesNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(3);
  const showNext = useCallback(() => {
    setIndex(prev => (prev + 1) % sales.length);
    setMinutesAgo(Math.floor(Math.random() * 12) + 1);
    setVisible(true);
  }, []);
  useEffect(() => {
    // First popup after a short delay
    const initial = setTimeout(showNext, 4000);
    return () => clearTimeout(initial);
  }, [showNext]);
  useEffect(() => {
    if (!visible) return;
    const hide = setTimeout(() => setVisible(false), VISIBLE_MS);
    return () => clearTimeout(hide);
  }, [visible]);
  useEffect(() => {
    if (visible) return;
    const next = setTimeout(showNext, HIDDEN_MS);
    return () => clearTimeout(next);
  }, [visible, showNext]);
  const sale = sales[index];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" aria-live="polite" data-id="element-171" data-mp="2wycwevohh3pa">
      <AnimatePresence data-id="element-172" data-mp="31w4vc9njpq2z">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 30,
        scale: 0.9
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto flex items-center gap-3 bg-navy-900 border border-navy-700 rounded-xl shadow-2xl p-3 pr-9 max-w-[300px] relative" data-id="element-173" data-mp="36ug56kduc0l7">
            <button onClick={() => setVisible(false)} aria-label="Dismiss notification" className="absolute top-2 right-2 text-gray-500 hover:text-gray-300 transition-colors focus:outline-none" data-id="element-174" data-mp="3fae4ms3axw9">
              <X className="w-4 h-4" data-id="element-175" data-mp="1rvk3vq3b8y1n" />
            </button>

            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-500/15 flex items-center justify-center" data-id="element-176" data-mp="1nuqcgmqnt140">
              <CheckCircle className="w-6 h-6 text-green-500" data-id="element-177" data-mp="1ixgnt9b3gth8" />
            </div>

            <div className="min-w-0" data-id="element-178" data-mp="1dzoo3t47k32h">
              <p className="text-sm text-white font-medium leading-tight" data-id="element-179" data-mp="2blw3ly21vftm">
                <span className="font-bold" data-id="element-180" data-mp="2bl2wgvz6ioay">{sale.name}</span> from{' '}
                <span className="text-gold-400" data-id="element-181" data-mp="26o40e7vyg7a4">{sale.location}</span>
              </p>
              <p className="text-xs text-gray-400 leading-tight mt-0.5" data-id="element-182" data-mp="21vazjv3lxj3b">
                just purchased Football Ready: System 365
              </p>
              <p className="text-[11px] text-gray-500 mt-1 flex items-center gap-1" data-id="element-183" data-mp="1wuvhwrcalpfj">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" data-id="element-184" data-mp="2udoloxfkzgmk"></span>
                {minutesAgo} minute{minutesAgo === 1 ? '' : 's'} ago · Verified
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}